import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
  },
});

// Thunk for fetching expenses summary
export const fetchExpensesSummary = createAsyncThunk(
  'expenses/fetchSummary',
  async (days = 7, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/ExpensesSummary/?days=${days}`);
      return response.data.reverse();
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch expenses summary');
    }
  }
);

const initialState = {
  summaryData: [],
  selectedDay: null,
  status: 'idle',
  error: null,
  filterDays: 7,
};

const expensesSummarySlice = createSlice({
  name: 'expensesSummary',
  initialState,
  reducers: {
    setSelectedDay: (state, action) => {
      state.selectedDay = action.payload;
    },
    setFilterDays: (state, action) => {
      state.filterDays = action.payload;
      state.selectedDay = null; // Reset selected day when changing filter
    },
    clearSelectedDay: (state) => {
      state.selectedDay = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExpensesSummary.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchExpensesSummary.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.summaryData = action.payload;
      })
      .addCase(fetchExpensesSummary.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

// Selectors
export const selectAllExpenses = (state) => state.expensesSummary.summaryData;
export const selectSelectedDay = (state) => state.expensesSummary.selectedDay;
export const selectStatus = (state) => state.expensesSummary.status;
export const selectError = (state) => state.expensesSummary.error;
export const selectFilterDays = (state) => state.expensesSummary.filterDays;

export const { setSelectedDay, setFilterDays, clearSelectedDay } = expensesSummarySlice.actions;
export default expensesSummarySlice.reducer;